import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header, Footer, StickyMobileCTA } from "@/components/chrome";
import { getMeta } from "@/lib/seo";

function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = getMeta(pathname, window.location.origin);
    document.title = m.title;
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement(sel.startsWith("link") ? "link" : "meta");
        if (sel === 'meta[name="description"]') el.setAttribute("name", "description");
        if (sel === 'meta[name="keywords"]') el.setAttribute("name", "keywords");
        if (sel === 'link[rel="canonical"]') el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    set('meta[name="description"]', "content", m.description);
    set('meta[name="keywords"]', "content", m.keywords);
    set('link[rel="canonical"]', "href", window.location.origin + pathname);
  }, [pathname]);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
}

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#FAFAFC] font-sans text-slate-600 antialiased">
      <SeoManager />
      <ScrollToTop />
      <SmoothScroll />
      <Header />
      <main className="pb-24">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
